import React, { Component } from "react";
import { connect } from "react-redux";
import classNames from "classnames";

import { Logo, Input, InputError, NextStepButton } from "components";

import { UPDATE_INPUT, MOVE_TAB } from "actions";

class Tab0B extends Component {
  state = {
    fullNameError: false
  };
  updateInput = data => {
    this.setState({
      [data.name + "Error"]: data.value !== "" ? false : true
    });
    this.props.updateInput(data);
  };
  moveToNextTab = () => {
    const { fullName } = this.props;

    const fullNameError = fullName === "" ? true : false;

    this.setState({
      fullNameError
    });

    if (fullNameError) {
      return;
    }

    this.props.moveToNextTab();
  };
  render() {
    const props = this.props;
    const state = this.state;
    return (
      <div className="form_steps test_tab0b">
        <div className="form_steps--inner flex">
          <div className="form_steps--column">
            <div className="full_column">
              <Logo />
              <div className="form_content">
                <h2 className="form_content--title">{props.domain.Strings.tab0bheading}</h2>
                <div className="fields_container">
                  <div className={classNames("field_block field_block--fill", { error: state.fullNameError })}>
                    <label> {props.domain.Strings.tab0NameLabel}</label>
                    <Input value={props.fullName} onChange={this.updateInput} name="fullName" className="test_tab0bFullName" />
                    {state.fullNameError && <InputError label={props.domain.Strings.tab0NameError} />}
                  </div>
                  <div className="field_block">
                    <label> {props.domain.Strings.tab0PhoneLabel}</label>
                    <Input value={props.phoneNumber} onChange={props.updateInput} type="tel" name="phoneNumber" className="test_tab0bPhoneNumber" />
                  </div>
                  <NextStepButton text={props.domain.Strings.tab0NextButton} onClick={this.moveToNextTab} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
//{props.domain.Strings.tab0BTitle}
const mapStateToProps = state => {
  return {
    ...state.app
  };
};
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    updateInput: ({ name, value }) => dispatch({ type: UPDATE_INPUT, name, value }),
    moveToNextTab: () => dispatch({ type: MOVE_TAB, dir: "next", from: ownProps.tab })
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Tab0B);
